import { message as $message } from 'antd'
import { querySubCompanyUserListForAgentLogin } from '@/services/supplier'

export const getUserList = async coId => {
    const { success, message, data } = await querySubCompanyUserListForAgentLogin({ coId })
    if (success) {
        const temp = data.subAccounts?.map(item => ({
            ...item,
            authorized: item.authorized || data.allowDirectProxyLogin
        }))
        return temp || []
    } else {
        $message.error(message)
    }
}
